import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { IWeissmanModalComponent } from '../../../../Compliance/WeissmanModalService';
import { SavedSearchCategoryEnum } from '../../../../constants.new';
import { ReportManagerService } from '../../../../Reporting/Manager/report.manager.service';
import { UserSaveService } from '../../userSave.service';

export interface ReportCategoryModalParams {
    report: Core.ReportListDTO;
    reportType: Core.SearchCategoryType;
}

@Component({
    selector: 'report-category',
    templateUrl: './navChangeCategory.component.html',
    standalone: false
})
export class ReportCategoryComponent implements IWeissmanModalComponent<ReportCategoryModalParams, void>, OnInit {
    constructor(private readonly _reportManagerService: ReportManagerService,
                private readonly _userSaveService: UserSaveService,
                private readonly _bsModalRef: BsModalRef) {
    }

    params: ReportCategoryModalParams;
    result: void;

    modalTitle: string;
    report: Core.ReportListDTO;
    reportType: Core.SearchCategoryType;
    categories: any[] = [];
    selectedCategory: any;
    newCategory: string;
    creatingNewCategory = false;

    async ngOnInit(): Promise<void> {
        this.report = this.params.report;
        this.reportType = this.params.reportType;
        this.modalTitle = `Change "${this.report.reportName}" View's Category`;

        const results = await this._reportManagerService.getReportCategories();

        if (results && results.length) {
            this.categories = results.filter(item => {
                return item.categoryType === this.reportType && (item.categoryId != SavedSearchCategoryEnum.ComplianceReport &&
                    item.categoryId != SavedSearchCategoryEnum.ComplianceReturnReport &&
                    item.categoryId != SavedSearchCategoryEnum.CompliancePackageReport &&
                    item.categoryId != SavedSearchCategoryEnum.ComplianceCustomReport);
            });
            this.selectedCategory = this.categories.find(x => x.categoryId === this.report.categoryId) || this.categories[0];
        }
    }

    async save(): Promise<void> {
        //Create new category first, then update view
        if (this.selectedCategory.categoryId === -1) {
            const category = { ...this.selectedCategory };
            delete category.categoryId;

            const result = await this._reportManagerService.createCategory(category.categoryName, this.reportType === Core.SearchCategoryType.System);

            this.report.categoryId = result.categoryId;
            this.selectedCategory.categoryId = result.categoryId;
        }

        await this._reportManagerService.changeCategory(this.reportType, this.report, this.selectedCategory.categoryId);
        await this._userSaveService.refreshCurrentList();

        this._bsModalRef.hide();
    }

    cancel() {
        this._bsModalRef.hide();
    }

    createNewCategory(): void {
        if (!this.newCategory) {
            this.creatingNewCategory = false;
            return;
        }

        let category;
        if (this.categories.some(x => x.categoryId === -1)) {
            category = this.categories.find(x => x.categoryId === -1);
            category.categoryName = this.newCategory;
            category.categoryType = this.reportType;
        } else {
            category = {
                categoryName: this.newCategory,
                categoryType: this.reportType,
                categoryId: -1
            };
            this.categories.push(category);
        }

        this.selectedCategory = category;
        this.report.categoryId = -1;
        this.creatingNewCategory = false;
        this.newCategory = '';
    }

    cancelCreateCategory(): void {
        this.creatingNewCategory = false;
        this.newCategory = '';
    }
}
